// Explore-stats page: Senate casual vacancies (#223).
// Sourced from the `casual_vacancies` index (Parliamentary Handbook API) —
// s.15 appointments where a State/Territory parliament fills a Senate vacancy
// mid-term. Flagship: chronological, sortable table of every appointment with
// the replacement senator (linked to their profile), party, State filled, and
// the reason the seat fell vacant. Slices: by State, by party, by reason, by
// decade.

import React, { useState, useEffect } from 'react';
import { Paper, Typography, Grid } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import { StatBar } from './charts';

export default function CasualVacancies() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getExploreStat('casual-vacancies');
        if (active) setData(res);
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const charts = data?.charts || {};

  return (
    <ExploreStatsPage
      title="Senate casual vacancies"
      description={`Section 15 appointments since Federation${
        charts.total ? ` (${charts.total})` : ''
      } — senators chosen by a State or Territory parliament to fill a Senate vacancy mid-term. Each appointee links to their profile; State and reason are parsed from the official note.`}
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="senate-casual-vacancies"
    >
      {data && (
        <>
          <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>Casual vacancies per decade</Typography>
            <StatBar data={charts.by_decade || []} xKey="decade" yKey="count" height={300} />
          </Paper>

          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>By State</Typography>
                <StatBar data={charts.by_state || []} xKey="state" yKey="count"
                         layout="vertical" height={300} />
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>By reason vacated</Typography>
                <StatBar data={charts.by_reason || []} xKey="reason" yKey="count"
                         layout="vertical" height={300} />
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>By party (replacement)</Typography>
                <StatBar data={charts.by_party || []} xKey="party" yKey="count"
                         layout="vertical" height={300} />
              </Paper>
            </Grid>
          </Grid>
        </>
      )}
    </ExploreStatsPage>
  );
}
